var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotAllowed = function SvgNotAllowed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 2C9.3 2 10.5 2.4 11.5 3.1L3.1 11.5C2.4 10.5 2 9.3 2 8C2 4.7 4.7 2 8 2ZM8 14C6.7 14 5.5 13.6 4.5 12.9L12.9 4.5C13.6 5.5 14 6.7 14 8C14 11.3 11.3 14 8 14Z",
    fill: "#F93A3A"
  })));
};
export default SvgNotAllowed;